import { Nullable } from '@tager/web-core';

import { SEOTemplate } from '@/typings/model';

export const getSingleDealerSeo = (
  dealer: string,
  brand: string,
  seoTemplate: Nullable<SEOTemplate>
): Nullable<SEOTemplate> => {
  if (!seoTemplate) {
    return null;
  }

  const { title, description } = seoTemplate;

  const replaceText = (text: Nullable<string>): Nullable<string> => {
    return (
      text?.replaceAll('{{dealer}}', dealer)?.replaceAll('{{brand}}', brand) ??
      text
    );
  };

  return {
    ...seoTemplate,
    title: replaceText(title),
    description: replaceText(description),
  };
};
